import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        if (!sid) throw new Error("no session id");
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#07090E]">
      <div className="flex items-center gap-3 text-cyan-neon">
        <span className="w-3 h-3 rounded-full bg-cyan-400 radar-dot" />
        <span className="font-mono-num text-sm tracking-widest">SIGNING YOU IN…</span>
      </div>
    </div>
  );
}
